import Vue from "vue";
import moment from "moment";
import 'moment/locale/sr'
import 'moment/locale/en-in'

moment.locale(process.env.VUE_APP_I18N_LOCALE)

Vue.prototype.$moment = moment;
